import React from 'react';

// in progress --- dont use

interface ArrowProps {
  key?: string;
  'data-role'?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<any>;
  currentSlide?: number;
  slideCount?: number;
}

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="40" viewBox="0 0 25 44" fill="none">
    <path d="M23 2L3 22L23 42" stroke="#C4C4C4" strokeWidth="4" />
  </svg>
);

const svg_rounded = (
  <svg id='arrow' xmlns="http://www.w3.org/2000/svg" width="5" height="10" viewBox="0 0 25 44" fill="none">
    <path  className="arrow-path" stroke='#141D38' d="M23 2L3 22L23 42" strokeWidth="4" />
  </svg>
);


const NextArrow = (props: ArrowProps) => {
  const { onClick, className } = props;
  return <div className={`v2-slick-arrow next-arrow ${className}`} onClick={onClick}>{svg}</div>;
};

const PrevArrow = (props: ArrowProps) => {
  const { onClick, className } = props;
  return (
    <div className={`v2-slick-arrow prev-arrow ${className}`} onClick={onClick}>{svg}</div>
  );
};

const RoundedNextArrow = (props: ArrowProps) => {
  const { onClick, className } = props;
  return <div className={`v2-slick-arrow next-arrow ${className}`} onClick={onClick}>{svg_rounded}</div>;
};

const RoundedPrevArrow = (props: ArrowProps) => {
  const { onClick, className } = props;
  return <div className={`v2-slick-arrow prev-arrow ${className}`} onClick={onClick}>{svg_rounded}</div>;
};


const SlickArrows = {
  PrevArrow,
  NextArrow,
  RoundedNextArrow,
  RoundedPrevArrow
};

export default SlickArrows;
